import Skeleton from '@mui/material/Skeleton';

import React from 'react';
import { Grid } from '@mui/material';

import { sxStyle } from './styles';

const loadingRows = [...Array(20).keys()];

const FlightsSearchSkeleton = () => {
  return (
    <Grid sx={sxStyle.rootLoating}>
      <Grid container>
        <Grid item container lg={3} xs={12}>
          <Skeleton
            variant="rect"
            animation="wave"
            sx={sxStyle.skeletonFilter}
          />
        </Grid>
        <Grid item container lg={9} xs={12}>
          <Skeleton variant="text" animation="wave" sx={sxStyle.skeletonText} />
          {loadingRows.map(item => {
            return (
              <Skeleton
                key={item}
                variant="rect"
                width={'100%'}
                height={275}
                style={{ margin: '10px 0px', borderRadius: '8px' }}
                animation="wave"
              />
            );
          })}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FlightsSearchSkeleton;
